import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-equalizer",
  templateUrl: "./med-icon-equalizer.component.html",
})
export class MedIconEqualizerComponent extends SvgMixinComponent {}
